import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { Injectable } from '@angular/core';
import { RxAppService } from 'app/rx/services/rx-app.service';
import { RxPDFRequested } from '@itero/itero-client-communication';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RxPdfRequestedEvent implements IShellEvent {

	constructor(private readonly rxAppService: RxAppService) {
	}

	get eventName(): string {
		return ShellCommunicationEvents.RxPdfRequested;
	}

	handleCustomEvent(event: RxPDFRequested) {
		this.rxAppService.getRxReferralAndDownloadPdf(event.data.rx).
			pipe(take(1)).
		subscribe();
	}

	handlePostMessage(event): void {
	}
}
